import ResourceContentType from "./ResourceContentType";

const ResourceContentTypeToFilterTypes: Record<ResourceContentType, Array<string>> = {
  [ResourceContentType.ARCHIVE]: [
    "application/zip",
    "application/x-zip-compressed",
    "application/x-rar-compressed",
    "application/x-7z-compressed",
    "application/x-tar",
    "application/gzip",
  ],
  [ResourceContentType.AUDIO]: [
    "audio",
    "audio/mpeg",
    "audio/mp3",
    "audio/wav",
    "audio/ogg",
    "audio/webm",
    "audio/x-m4a",
  ],
  [ResourceContentType.DOCUMENT]: [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.oasis.opendocument.text",
    "application/rtf",
    "text/plain",
    "text/rtf",
    "text/richtext",
    "application/vnd.apple.pages",
  ],
  [ResourceContentType.IMAGE]: [
    "image",
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp",
    "image/svg+xml",
    "image/bmp",
    "image/tiff",
    "image/heic",
  ],
  [ResourceContentType.LINK]: [], // URLs only, no MIME type
  [ResourceContentType.PDF]: ["application/pdf"],
  [ResourceContentType.PRESENTATION]: [
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.apple.keynote",
  ],
  [ResourceContentType.SPREADSHEET]: [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    "application/vnd.oasis.opendocument.spreadsheet",
    "application/vnd.apple.numbers",
    "application/csv",
    "text/csv",
  ],
  [ResourceContentType.VIDEO]: [
    "video",
    "video/mp4",
    "video/x-msvideo",
    "video/x-matroska",
    "video/webm",
    "video/ogg",
    "video/quicktime",
    "video/x-ms-wmv",
    "video/x-flv",
  ],
};

export default ResourceContentTypeToFilterTypes;
